import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  loading: false,
  finDashData: [],
  finDetailDashData: [],
  finDashDetails: [],
};

export const getFinDashboard = createAsyncThunk('finance/getFinDashboard', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `analytics/finance-dashboard?fromDate=${data.date}&currency=${data.currency}&batchStatus=${data.batchStatus}`,
  });

  return res;
});

export const getDetailDash = createAsyncThunk('finance/getDetailDash', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `analytics/finance-dashboard/weekly/${data.projectId}?fromDate=${data.date}&page=${data.page}&limit=${data.limit}&search=${data.search}&batchStatus=${data.batchStatus}&currency=${data.currency}`,
  });

  return res;
});

export const getFinDashDetails = createAsyncThunk('finance/getFinDashDetails', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `analytics/finance-dashboard/details/${data.croId}/${data.projectId}?fromDate=${data.fromDate}&page=${data.page}&limit=${data.limit}&search=${data.search}&batchStatus=${data.batchStatus}&currency=${data.currency}&feeStatus=${data?.feeStatus || null}`,
  });

  return res;
});

const financeSlice = createSlice({
  name: 'finance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //.................getLocalBodyPreData..............................
    builder.addCase(getFinDashboard.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getFinDashboard.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        finDashData: data,
        loading: false,
      };
    });
    // ------------------getDetailDash-------------------------------
    builder.addCase(getDetailDash.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getDetailDash.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        finDetailDashData: data,
        loading: false,
      };
    });
    // -----------------------getFinDashDetails----------------------------------
    builder.addCase(getFinDashDetails.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getFinDashDetails.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        finDashDetails: data,
        loading: false,
      };
    });
  },
});

export default financeSlice.reducer;
